import { render } from "./BaseCurrencyInput.vue?vue&type=template&id=c1543816"
import script from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
export * from "./BaseCurrencyInput.vue?vue&type=script&lang=js"

import "./BaseCurrencyInput.vue?vue&type=style&index=0&id=c1543816&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__